import GameModel from './GameModel';
import * as PIXI from 'pixi.js';
import HudRenderer from 'src/Pixi/HudRenderer';

const textSize = 24;

export class Countdown {
    private startAt: number;
    private countdown: PIXI.Text;
    private metrics: PIXI.TextMetrics;

    public constructor(public duration: number, public message: string) {
        // Just sets passed properties
    }

    public start(): void {
        this.startAt = Date.now();

        const text = `${this.message} ${this.durationLeft()}`;
        const style = new PIXI.TextStyle({
            fontFamily: 'Arial',
            fontSize: textSize,
            fill: 0xffffff,
            align: 'center',
        });
        this.countdown = new PIXI.Text(text, style);
        this.metrics = PIXI.TextMetrics.measureText(text, style);
        this.positionText();
        GameModel.uiContainer.addChild(this.countdown);
        HudRenderer.setCountdown(this);
    }

    public finish(): void {
        GameModel.uiContainer.removeChild(this.countdown);
        HudRenderer.clearCountdown();
    }

    public tick(): void {
        this.countdown.text = `${this.message} ${this.durationLeft()}`;
    }

    public durationLeft(): number {
        const timeLeft = this.duration - (Date.now() - this.startAt) / 1000;
        return Math.ceil(Math.max(timeLeft, 0));
    }

    public reflow(_width: number, _height: number): void {
        this.positionText();
    }

    private positionText(): void {
        this.countdown.position.set(window.innerWidth / 2 - this.metrics.width / 2, textSize);
    }
}



// WEBPACK FOOTER //
// ./src/game/Countdown.ts